import React, { useState } from "react";
import EditableText from "./EditableText";
import { DialogContentText, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteCategories, saveCategories } from "../../data";
import { useShoppingListDispatch } from "../../contexts/ShoppingListContext";
import ConfirmDialog from "./ConfirmDialog";

export interface AisleHeaderProps {
    uniqueId: string;
    id?: number;
    name?: string | null;
    sort_order: number;
}

export default function AisleHeader({ uniqueId, id, name, sort_order }: AisleHeaderProps) {
    const dispatch = useShoppingListDispatch();
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);

    const onRename = async (newName: string) => {
        if (!name || id === undefined) return;

        const [newId] = await saveCategories([{ id: id, name: newName, sort_order: sort_order }]);

        dispatch({ type: "rename-category", category: uniqueId, newName, newId });
    };

    const onCancelRename = () => {
        if (typeof id === "number") return;

        dispatch({ type: "remove-category", category: uniqueId });
    };

    const onRemove = () => {
        setRemoveDialogOpen(true);
    };

    const onRemoveConfirm = async () => {
        if (id) {
            await deleteCategories([{ id }]);
        }

        dispatch({ type: "remove-category", category: uniqueId });
    };

    const categoryHeader = name ? (
        <EditableText key={id || ""} value={name} onCommit={onRename} onCancel={onCancelRename} initialIsEditing={!id}>
            <IconButton onClick={onRemove} sx={{ marginLeft: "30px" }}>
                <DeleteIcon />
            </IconButton>
        </EditableText>
    ) : (
        <>Ingen kategori</>
    );

    return (
        <>
            {categoryHeader}
            <ConfirmDialog
                open={removeDialogOpen}
                title={`Ta bort '${name}'`}
                confirmText="Ta bort"
                onConfirm={onRemoveConfirm}
                onCancel={() => setRemoveDialogOpen(false)}
            >
                <DialogContentText>
                    Om du tar bort kategorin så kommer alla ingredienser i {name} sorteras som okategoriserat. Vill du
                    fortsätta?
                </DialogContentText>
            </ConfirmDialog>
        </>
    );
}
